import {
   Routes,
   Route,
   Navigate,
   useLocation,
   useNavigate,
} from "react-router-dom";
import NoticePage from "./pages/NoticePage";
import TosPage from "./pages/TosPage";
import NoticeServicePage from "./pages/NoticeServicePage";
import TosDetailPage from "./pages/TosDetailPage";
import { createUseStyles } from "react-jss";
import { ThemeType } from "./styles/theme";
import javascriptHandler from "./apis/javascriptHandler";
import { useEffect, useState } from "react";
import Zzeung from "./lib/myid-sdk-client-web/build/myid-sdk-client-web.min.js";
import GuidePage from "./pages/GuidePage";
import GuideDetailPage from "./pages/GuideDetailPage";
import AdBannerPage from "./pages/AdBannerPage";
import ContactPage from "./pages/ContactPage";
import FaqPage from "./pages/FaqPage";
import OssPage from "./pages/OssPage";
import OnboardAgrPage from "./pages/OnboardAgrPage";
import UnderageAgrPage from "./pages/UnderageAgrPage";
import AgrTosDetailPage from "./pages/AgrTosDetailPage";

import { PrivacyPolicyPage, ServicePage } from "./pages/PolicyPage";

const useStyles = createUseStyles((theme: ThemeType) => ({
   "@global": {
      html: {
         fontSize: "62.5%",
         fontFamily: theme.font,
         letterSpacing: "-0.05rem",
         color: theme.mono0,
         fontWeight: theme.demiLight,
         lineHeight: "2.6rem",
         background: theme.mono100,
      },
      body: {
         fontSize: "1.6rem",
         "-webkit-font-smoothing": "antialiased",
         "-moz-osx-font-smoothing": "grayscale",
         lineHeight: "2.6rem",
         background: theme.mono100,
      },
      ".container": {
         width: "100%",
         margin: "0 auto",
         padding: `30px ${theme.gap}px 0px`,
         background: theme.mono100,
      },
      a: {
         fontSize: "1.4rem",
         color: theme.primaryTxt,
         textDecoration: "none",
         outline: "none",
         "&:hover": {
            textDecoration: "none",
            color: theme.primaryTxt,
         },
         "&:active": {
            textDecoration: "none",
            color: theme.primaryTxt,
         },
      },
   },
}));
function App() {
   useStyles();
   javascriptHandler.initJavascriptHandler();

   const location = useLocation();
   const [prevUrl, setPrevUrl] = useState<string>("");
   const [error, setError] = useState(null);
   const handleError = (error: any) => {
      setError(error);
   };

   useEffect(() => {
      const curUrl = window.location.href;
      window.scrollTo(0, 0);
      try {
         if (prevUrl !== curUrl) {
            Zzeung._callHandler("a_webview_page_view", {
               page_location: curUrl,
               page_referrer: prevUrl,
            });
            setPrevUrl(curUrl);
         }
      } catch (e) {
         handleError(new Error(`Failed to call handler: ${e}`));
      }
   }, [location, prevUrl]);
   return (
      <>
         <Routes>
            <Route path="/notice" element={<NoticePage />} />
            <Route path="/notice/service" element={<NoticeServicePage />} />
            <Route path="/tos" element={<TosPage />} />
            <Route path="/tos/:tosId" element={<TosDetailPage />} />
            <Route path="/tos/3" element={<PrivacyPolicyPage />} />
            <Route path="/tos/0" element={<ServicePage />} />
            <Route path="/guide" element={<GuidePage />} />
            <Route path="/guide/:guideId" element={<GuideDetailPage />} />
            <Route path="/banner" element={<AdBannerPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/oss" element={<OssPage />} />
            <Route path="/agr/onboard" element={<OnboardAgrPage />} />
            <Route path="/agr/underage" element={<UnderageAgrPage />} />
            <Route path="/agr/tos/:tosId" element={<AgrTosDetailPage />} />
            {/* <Route path="/contact" element={<ContactPage />} /> */}

            {/* <Route path="/quarantine/intro" element={QuarantineIntroPage} />
            <Route path="/quarantine/privacy" element={QuarantineAgrPage} /> */}
            {/* <Route path="/prev" element={<TosPrevDetailPage/>} /> */}
         </Routes>
      </>
   );
}

export default App;
